import { render } from "./Info.vue?vue&type=template&id=8ab667de&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=8ab667de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ab667de"

export default script